import { useSelector } from "react-redux";
import {
    Box,
    Flex,
    Grid,
} from "@chakra-ui/react";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import ProfileSummary from "./components/ProfileSummary";
import PersonalInformation from "./components/PersonalInformation";
import SecurityCard from "./components/SecurityCard";
import ReferralCard from "./components/ReferralCard";
import MarketplaceCard from "./components/MarketplaceCard";
import AccountManagement from "./components/AccountManagement";

const Profile = () => {
const {
    driverPartner,
    referredDrivers = [],
    referralMilestones = [],
} = useSelector(
    (state) =>
        state.driverPartner
);
const totalEarned =
    referralMilestones
        .filter(
            milestone =>
                milestone.commission_status ===
                "Paid"
        )
        .reduce(
            (
                total,
                milestone
            ) =>
                total +
                Number(
                    milestone.commission_amount ||
                    0
                ),
            0
        );

const totalRecruits =
    referredDrivers.length;
    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Profile & Settings"
                        subtitle="Manage your account details, recruit earnings, and security preferences."
                    />

                    {/* Top */}

                    <Grid
                        templateColumns={{
                            base: "1fr",
                            xl: "2fr 360px",
                        }}
                        gap={6}
                        alignItems="start"
                    >
                        {/* Left Column */}
                        <Flex
                            direction="column"
                            gap={6}
                        >
                            <ProfileSummary  driverPartner={
        driverPartner
    } />

                            <PersonalInformation  driverPartner={
        driverPartner
    } />

                            <SecurityCard />
                        </Flex>

                        {/* Right Column */}
                        <Flex
                            direction="column"
                            gap={6}
                        >
                            <ReferralCard
                                driverPartner={
                                    driverPartner
                                }
                                totalRecruits={
                                    totalRecruits
                                }
                                totalEarned={
                                    totalEarned
                                }
                            />
                         

                            <AccountManagement />
                        </Flex>
                    </Grid>
                </Box>
            </Flex>
        </Flex>
    );
};

export default Profile;